import React from "react";
import { SidebarItem } from "./CaseLayout";
import { Brain, FileText, History } from "lucide-react";
import SidebarFeatureGateButton from "../../featureFlags/components/SideBarFeatureGateButton";
import { isDocumentsPanelEnabled } from "../../configs/logic/Slice";
import { CaseSidebarTooltip } from "./CaseSidebarTooltip";
import { useAppSelector } from "../../../../src/app/store";

interface CaseSidebarProps {
  selected: SidebarItem | null;
  onSelect: (value: SidebarItem) => void;
}

const CaseSidebar: React.FC<CaseSidebarProps> = ({ selected, onSelect }) => {
  const isDocuments = selected === SidebarItem.Documents;
  const isInsights = selected === SidebarItem.Insights;
  const isCaseTimeline = selected === SidebarItem.CaseTimeline;

  const isDocsEnabled = useAppSelector(isDocumentsPanelEnabled);

  return (
    <div
      className="
        h-full w-[48px]
        bg-white
        border-l border-[#E5E5E5]
        flex flex-col items-center
      "
    >
      <svg width="0" height="0" className="absolute">
        <defs>
          <linearGradient
            id="sidebar-gradient"
            x1="0"
            y1="0"
            x2="0"
            y2="24"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#788AF7" />
            <stop offset="1" stopColor="#3551F3" />
          </linearGradient>
        </defs>
      </svg>

      <div className="w-full flex flex-col items-center pt-[40px] gap-2">
        {/* TODO: Enable Insights sidebar button once AI Insights navigation
  is moved here. Currently, AI Insights is triggered from the
  header action button.*/}

        {/* <button
          onClick={() => onSelect(SidebarItem.Insights)}
          className={`
            h-8 w-8
            flex items-center justify-center
            rounded-md
            transition-colors
            ${
              isInsights
                ? "bg-indigo-50"
                : "hover:bg-gray-100 bg-transparent"
            }
          `}
        >
          <Brain
            size={17}
            strokeWidth={2}
            className="transition-colors"
            color={isInsights ? "url(#sidebar-gradient)" : "#334155"}
          />
        </button> */}
         <CaseSidebarTooltip label="Case Timeline">
        <button
          onClick={() => onSelect(SidebarItem.CaseTimeline)}
          className={`
            h-8 w-8
            flex items-center justify-center
            rounded-md
            transition-colors
            ${
              isCaseTimeline
                ? "bg-indigo-50"
                : "hover:bg-gray-100 bg-transparent"
            }
          `}
        >
          <History
            size={17}
            strokeWidth={2}
            className="transition-colors"
            color={isCaseTimeline ? "url(#sidebar-gradient)" : "#334155"}
          />
        </button>
        </CaseSidebarTooltip>

       <CaseSidebarTooltip label="Documents" disabled={!isDocsEnabled}>
        <SidebarFeatureGateButton
          onClick={() => onSelect(SidebarItem.Documents)}
          isSelected={isDocuments}
          selector={isDocumentsPanelEnabled}
          disabledMessage="Document management is disabled due to the absence of an active DMS API integration."
          icon={
            <FileText
              size={17}
              strokeWidth={2}
              className="transition-colors"
              color={isDocuments ? "url(#sidebar-gradient)" : "#334155"}
            />
          }
        />
        </CaseSidebarTooltip>

      </div>

      <div className="flex-1" />
    </div>
  );
};

export default CaseSidebar;

